// routes/_authenticated/fundos/$cnpj/index.tsx — entry point for
// `/fundos/:cnpj` (the default child of the `$cnpj` layout route).
//
// ponytail: the route param is normalised to digits here rather than in the
// page. Links from the list already pass digits, but a pasted URL can carry
// a masked CNPJ, and the backend's splat segment would then arrive with the
// `/` of `0001-15` splitting the path.

import { toDigitsCnpj } from "@shared/utils/cnpj";
import { createFileRoute } from "@tanstack/react-router";

import { FundoDetailPage } from "@/features/fundos/detail";

export const Route = createFileRoute("/_authenticated/fundos/$cnpj/")({
  component: () => {
    const { cnpj } = Route.useParams();
    return <FundoDetailPage cnpj={toDigitsCnpj(cnpj) ?? cnpj} />;
  },
});
